import { getFoundation } from '../foundation';

import type { BreakpointsOptions } from '@mui/material';
import type { Foundation } from '@kep/kcds-foundation';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xl: false;
  }
}

export type FoundationBreakpointKey =
  | keyof Foundation['breakpoint']['minWidth']
  | keyof Foundation['breakpoint']['maxWidth'];

export type BreakpointKey = 'xs' | FoundationBreakpointKey;

export const createBreakpoints = (): BreakpointsOptions => {
  const foundation = getFoundation('light');

  const breakpointKeys = Object.keys(foundation.breakpoint.maxWidth).filter(
    isFoundationBreakpointKey(foundation),
  );

  const breakpoints = breakpointKeys.reduce(
    (acc, key) => {
      const value = foundation.breakpoint.minWidth[key];
      acc[key] = parseInt(value.replace('px', ''), 10);
      return acc;
    },
    { xs: 0 } as Record<BreakpointKey, number>,
  );

  return { values: breakpoints };
};

const isFoundationBreakpointKey =
  (foundation: Foundation) =>
  (key: string): key is FoundationBreakpointKey =>
    key in foundation.breakpoint.minWidth;
